import i18next from 'i18next';
import normalizeStringValue from '@commons/utils/normalizeStringValue';

const getSheetConfiguration = () => ({
  PRODUCT_FORECAST: {
    id: 'productForecasts',
    name: i18next.t('_BACKEND_TRANSLATIONS.PRODUCT_FORECASTS.IMPORTS.SHEET_NAME'),
  },
});

const getNormalizedColumnIds = () => ({
  PRODUCT_ID: { key: 'productId', normalizedKey: 'productid' },
  STORE_ID: { key: 'storeId', normalizedKey: 'storeid' },
  PRODUCT_NAME: {
    key: 'productName',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.PRODUCT_FORECASTS.IMPORTS.PRODUCT_NAME'),
    ),
  },
  PRODUCT_CATEGORY: {
    key: 'productCategory',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.PRODUCT_FORECASTS.IMPORTS.PRODUCT_CATEGORY'),
    ),
  },
  STORE_NAME: {
    key: 'storeName',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.PRODUCT_FORECASTS.IMPORTS.STORE_NAME'),
    ),
  },
});

export default {
  getSheetConfiguration,
  getNormalizedColumnIds,
};
